import {
  ContentType,
  ContentTypeFormat,
  Field,
  VersionInfo,
} from 'contensis-core-api';
import { LocalisedString } from 'contensis-core-api/lib/models/Localised';
import {
  CaptchaSettings,
  ConfirmationRuleReturnContent,
  FieldDataFormat,
  FieldDataType,
  FieldEditor,
  FieldValidations,
  FormRule,
  Nullable,
} from './FormContentType';
import {
  ContentTypeBase,
  ContentTypeGroup,
} from 'contensis-core-api/lib/models/ContentTypeBase';

export interface FormContentType extends ContentTypeBase<'form'> {
  defaultLanguage?: string;
  entryTitleField?: string;
  supportedLanguages?: string[];
  groups?: ContentTypeGroup[];
  fields: FormField[];
  properties?: Nullable<FormProperties>;
  dataFormat: 'form';
}

export type FormField = Field & {
  dataType: FieldDataType;
  dataFormat?: FieldDataFormat;
  validations?: Nullable<FieldValidations>;
  editor?: Nullable<FieldEditor>;
};

export type FormProperties = {
  captcha: CaptchaSettings;
  localizations: Nullable<{
    submit?: Nullable<string>;
    next?: Nullable<string>;
    previous?: Nullable<string>;
    errorSummaryTitle?: Nullable<string>;
  }>;
  confirmationRules: FormRule<ConfirmationRuleReturn>[];
  autoSaveProgress: boolean;
  mode?: 'survey';
};

/** Unique to Management API */
export type ConfirmationRuleReturnNodeId = {
  link: {
    sys: {
      node: { id: string };
    };
  };
};
export type ConfirmationRuleReturn =
  | ConfirmationRuleReturnNodeId
  | ConfirmationRuleReturnContent;
